export const AUTH_POPUP_SUCCESS_EVENT = 'chat:auth-popup-success'
export const AUTH_POPUP_READY_EVENT = 'chat:auth-popup-ready'
export const AUTH_POPUP_PARENT_READY_EVENT = 'chat:auth-popup-parent-ready'
export const AUTH_POPUP_CLOSE_EVENT = 'chat:auth-popup-close'
export const AUTH_POPUP_WINDOW_NAME = 'chatbot-auth-popup'
export const AUTH_POPUP_MODE_QUERY_KEY = 'mode'
export const AUTH_POPUP_MODE_QUERY_VALUE = 'popup'
